module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp1_1.d2cc437b.png";